import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TagUser } from 'src/app/models';
import { TagType } from "../enums";

@Injectable()
export class TagsUserService {
  url: string;

  constructor(
    private httpClient: HttpClient,
    @Inject('API_URL') apiUrl: string
  ) {
    this.url = apiUrl + 'TagsUser/';
  }

  getById(id: number): Observable<TagUser> {
    const response: Observable<TagUser> = this.httpClient.get<TagUser>(`${this.url}${id}`);
    return response;
  }

  getAllUsers(tagType: TagType): Observable<TagUser[]> {
    const response = this.httpClient.get<TagUser[]>(`${this.url}get-all-users/${tagType as number}`);
    return response;
  }

  getAllById(userId: string, tagType: TagType): Observable<TagUser[]> {
    const response = this.httpClient.get<TagUser[]>(`${this.url}get-by-userid/${userId}/${tagType as number}`);
    return response;
  }

  getAllFromType(tagId: number): Observable<TagUser[]>{
    const response = this.httpClient.get<TagUser[]>(`${this.url}get-all-from-tag/${tagId}`);
    return response;
  }

  save(tag: TagUser): Observable<TagUser> {
      const response = this.httpClient.post<TagUser>(`${this.url}save`, tag);
      return response;
  }

  delete(tagId: number): Observable<void> {
      const response = this.httpClient.delete<void>(`${this.url}${tagId}`);
      return response;
  }
}